module.exports = __webpack_public_path__ + "static/media/background-form-for-owners.267b0859.jpg";